import React from "react";

/**
 * Semicircular gauge for KFRE risk visualization.
 * @param {number} value 0-100
 * @param {string} label
 */
export default function RiskGauge({ value, label, testId }) {
  const v = Math.max(0, Math.min(100, value || 0));
  const size = 220;
  const stroke = 16;
  const r = (size - stroke) / 2;
  const c = Math.PI * r; // half circle circumference
  const offset = c * (1 - v / 100);

  const color = v < 5 ? "#4ADE80" : v < 15 ? "#FBBF24" : "#F87171";

  return (
    <div className="flex flex-col items-center" data-testid={testId}>
      <div className="relative" style={{ width: size, height: size / 2 + 10 }}>
        <svg width={size} height={size / 2 + stroke} viewBox={`0 0 ${size} ${size / 2 + stroke}`}>
          <path
            d={`M ${stroke / 2} ${size / 2} A ${r} ${r} 0 0 1 ${size - stroke / 2} ${size / 2}`}
            fill="none"
            stroke="#1C201E"
            strokeWidth={stroke}
            strokeLinecap="round"
          />
          <path
            d={`M ${stroke / 2} ${size / 2} A ${r} ${r} 0 0 1 ${size - stroke / 2} ${size / 2}`}
            fill="none"
            stroke={color}
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeDasharray={c}
            strokeDashoffset={offset}
            style={{
              transition: "stroke-dashoffset 900ms ease, stroke 250ms ease",
              filter: `drop-shadow(0 0 10px ${color}55)`,
            }}
          />
        </svg>
        <div className="absolute inset-x-0 bottom-0 flex flex-col items-center pb-1">
          <div className="ros-metric text-4xl">{v.toFixed(1)}%</div>
        </div>
      </div>
      <div className="ros-label mt-3">{label}</div>
    </div>
  );
}
